import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'z-money',
  templateUrl: './money.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class MoneyComponent implements OnInit {
  @Input() id: string;

  @Input() fieldName: string;

  @Input() label?: string;
  @Input() hint?: string;
  @Input() placeholder?: string;
  @Input() readonly: boolean = false;
  @Input() size?: number;

  /**
   * If true any form validation errors will be displayed below the field (similar to a hint)
   */
  @Input() displayValidationErrors: boolean = true;

  @Input() clearButton: boolean = false;
  @Input() alignRight: boolean = true;

  @Input() currency: string = 'USD';
  @Input() currencyDisplay: string = 'symbol';
  @Input() useGrouping: boolean = true;

  @Input() minFractionDigits: number = 2;
  @Input() maxFractionDigits: number = 2;
  @Input() min?: number;
  @Input() max?: number;

  @Input() allowEmpty: boolean = true;

  @Input() styleClass?: string;
  @Input() containerStyleClass?: string;
  @Input() inputStyleClass?: string;

  @Input() maxlength?: number;

  @Output() clear = new EventEmitter<void>();

  constructor(private changeDetectorRef: ChangeDetectorRef, public formGroup: FormGroupDirective) {}

  ngOnInit() {
    if (!this.inputStyleClass) {
      this.inputStyleClass = `z-text-input`;
    } else {
      this.inputStyleClass = `${this.inputStyleClass} z-text-input`;
    }

    if (this.alignRight) {
      this.inputStyleClass = `${this.inputStyleClass} align-right`;
    }
  }

  update() {
    this.changeDetectorRef.markForCheck();
  }

  onClear(event: any) {
    this.clear.emit(event);
  }
}
